export const EVENTS = {
  USER_UPDATED: 'user-updated',
  THEME_UPDATED: 'theme-updated',
  REFERENCE_ID_UPDATED: 'reference-id-updated',
  CLEAR_CHAT: 'clear-chat',
} as const;

export type EventPayload = {
  [EVENTS.USER_UPDATED]: { user: any };
  [EVENTS.THEME_UPDATED]: { theme: 'light' | 'dark' };
  [EVENTS.REFERENCE_ID_UPDATED]: { reference_id: string };
  [EVENTS.CLEAR_CHAT]: {};
};

type EventCallback<T> = (payload: T) => void;

class EventBus {
  private listeners: Map<string, Set<EventCallback<any>>> = new Map();

  on<T>(event: string, callback: EventCallback<T>) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event)!.add(callback);
  }

  off<T>(event: string, callback: EventCallback<T>) {
    if (this.listeners.has(event)) {
      this.listeners.get(event)!.delete(callback);
    }
  }

  emit<T>(event: string, payload: T) {
    if (this.listeners.has(event)) {
      this.listeners.get(event)!.forEach(callback => {
        callback(payload);
      });
    }
  }
}

export const eventBus = new EventBus();
